module.exports = __webpack_public_path__ + "img/icon_dice.2fdf5f47.svg";